import { useQuery } from '@tanstack/react-query';
import { DateService, getSingleReport } from 'Services';
import { RQ_SINGLE_REPORT } from 'Utils';

function useSingleReport(recordId: number | null) {
    return useQuery([RQ_SINGLE_REPORT, recordId], () => getSingleReport(recordId!), {
        select: (data) => ({
            ...data,
            createdBy: data?.createdBy,
            createdAt: DateService.getDateTime(data?.createdAt)
        })
    });
}

export default useSingleReport;
